import React, { FC, Fragment, memo, useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Switch,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import Image from "shared/assets/index";
import style from "../../styles/detailedConsultation.module.scss";
import { IFieldForm } from "pages/read-documents/model/IFieldForm";
import {
  accesRoles,
  GET_CONTACT_NUMBER,
  GET_DATA_CONTRACT_STATUS,
  GET_ELECTRONIC_DOCS,
  Spinner,
} from "shared";
import { SwalAlertContent } from "../SwalAlertContent";
import { createRoot } from "react-dom/client";
import Swal from "sweetalert2";
import { putData } from "shared/api/services/putData";
import { ProvitionServiceDateField } from "../ProvitionServiceDateField";
import { getData, IMAster, getContractNumbers } from "shared/api/services";
import { TotalValueField } from "./TotalValueField";
import { FormFilter } from "shared/components/form-filter/FormFilter";
import { useEditContract } from "pages/contracts-pages/hook/useEditContract";
import { fieldsGeneralDataContract } from "pages/detailed-consultation/helpers/fieldsGeneralDataContract";
import { useContractContext } from "../../contexts/ContractContext";
import { useSelector } from "react-redux";

interface IStattusContract {
  T: IMAster;
  V: IMAster;
}

interface Props {
  contract: { id: any; status: IMAster };
  response: any;
  isEditing: boolean;
  setIsEditing: React.Dispatch<React.SetStateAction<boolean>>;
  onContractUpdate?: (contractNumber: string) => void;
}

export const GeneralContractInformation = memo(
  ({
    contract,
    response,
    isEditing,
    setIsEditing,
    onContractUpdate,
  }: Props) => {
    const {
      dataFields,
      getValueDatePickerStart,
      getValueDatePickerEnd,
      maxDate,
      onChangesDatePicker,
      handleSubmit,
      handleChange,
      values,
      loading,
    } = useEditContract(response, setIsEditing, contract.id);

    const { contractUpdated, resetContractUpdate } = useContractContext();

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<IFieldForm[]>([]);
    const [hasContract, setHasContract] = useState(false);
    const [isUpdatingContract, setIsUpdatingContract] = useState(false);
    const [statusContract, setStatusContract] = useState<IStattusContract>({
      T: { id: 0, name: "Terminado", code: "0" },
      V: { id: 0, name: "Vigente", code: "0" },
    });
    const [contractStatusOptions, setContractStatusOptions] = useState<
      { id: number; name: string }[]
    >([]);
    const modalComponent = document.createElement("div");
    const root = createRoot(modalComponent);

    const confirmUpdateStatus = () => {
      setIsLoading(true);
      putData(`${GET_CONTACT_NUMBER}/${contract.id}`, {
        stateId: hasContract ? statusContract.T.id : statusContract.V.id,
      })
        .then((res) => {
          Swal.clickCancel();
          const nextHasContract = !hasContract;
          setHasContract(nextHasContract);
          if (contract?.status) {
            contract.status = nextHasContract
              ? statusContract.V
              : statusContract.T;
          }
          if (response) {
            response.state = nextHasContract
              ? statusContract.V
              : statusContract.T;
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    };

    const confirmUpdateContractNumber = async (
      currentValue: string,
    ): Promise<any> => {
      console.log(
        " confirmUpdateContractNumber START - received currentValue:",
        currentValue,
      );
      console.log(" Type of currentValue:", typeof currentValue);
      console.log(" Length of currentValue:", currentValue?.length);
      setIsUpdatingContract(true);

      try {
        console.log(" About to call putData...");
        console.log(" Contract ID:", contract.id);
        console.log(
          " URL:",
          `${GET_ELECTRONIC_DOCS}/${contract.id}/contract-number`,
        );
        console.log(" Data to send:", { contractNumber: currentValue });

        const result = await putData(
          `${GET_ELECTRONIC_DOCS}/${contract.id}/contract-number`,
          {
            contractNumber: currentValue,
          },
        );

        // Determinar el nuevo estado basado en el valor del contrato
        const hasContractValue = Boolean(
          currentValue && currentValue.trim() !== "",
        );

        console.log(" About to call setHasContract with:", hasContractValue);
        console.log(" Current hasContract state before update:", hasContract);

        // Actualizar el estado inmediatamente
        setHasContract(hasContractValue);

        console.log(" setHasContract called with:", hasContractValue);

        // También actualizar en el backend si el estado es diferente
        const targetStateId = hasContractValue
          ? statusContract.V.id
          : statusContract.T.id;
        await putData(`${GET_ELECTRONIC_DOCS}/${contract.id}`, {
          stateId: targetStateId,
        });

        // Actualizar el response local para mantener sincronía
        if (response) {
          response.contractNumber = currentValue;
        }

        // Notificar al componente padre para actualizar su estado
        if (onContractUpdate) {
          console.log(" Calling onContractUpdate with:", currentValue);
          onContractUpdate(currentValue);
        } else {
          console.log(" onContractUpdate is not defined");
        }

        return result;
      } catch (error) {
        console.error("Error al actualizar el contrato:", error);
        throw error;
      } finally {
        setIsUpdatingContract(false);
      }
    };

    const confirmUpdateTotal = async (currentValue: string): Promise<any> => {
      return await putData(`${GET_CONTACT_NUMBER}/${contract.id}`, {
        totalValue: currentValue,
      });
    };

    const toogleHasContract = (e: any, checked: boolean) => {
      if (checked !== hasContract) {
        root.render(
          <SwalAlertContent
            description={`¿Está seguro de que desea cambiar el estado del contrato?`}
            onCancel={() => {
              Swal.clickCancel();
            }}
            onConfirm={() => confirmUpdateStatus()}
            textBtn="Sí"
            textCancel="No"
          />,
        );
        Swal.fire({
          title: "¡Atención!",
          icon: "warning",
          html: modalComponent,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    };

    useEffect(() => {
      getData(GET_DATA_CONTRACT_STATUS)?.then((res) => {
        const response = Array.isArray(res) ? res : [];
        setContractStatusOptions(response);
        const contractStatusObj: IStattusContract = {
          T: { id: 0, name: "Terminado", code: "0" },
          V: { id: 0, name: "Vigente", code: "0" },
        };
        response.forEach((item: any) => {
          if (item.name === "Terminado") {
            contractStatusObj.T = item;
          } else if (item.name === "Vigente") {
            contractStatusObj.V = item;
          }
        });
        setStatusContract(contractStatusObj);
      });
    }, []);

    // Efecto para inicializar el estado del switch basado en el número de contrato
    useEffect(() => {
      const contractNumber = response?.contractNumber;
      // Si hay estado definido en el backend, usarlo prioritariamente
      if (contract?.status?.name) {
        setHasContract(contract.status.name === "Vigente");
      } else if (contractNumber !== undefined && contractNumber !== null) {
        // Fallback: si no hay estado, usar presencia de número de contrato
        const hasContractValue = Boolean(
          contractNumber && contractNumber.trim() !== "",
        );
        setHasContract(hasContractValue);
      }
    }, [response?.contractNumber, contract?.status?.name]);

    useEffect(() => {
      if (contractUpdated) {
        if (contract?.id) {
          getContractNumbers(contract.id.toString())
            .then((updatedResponse: any) => {
              console.log(
                " Contract data reloaded after context update:",
                updatedResponse?.contractNumber,
              );
              // Resetear el flag del contexto
              resetContractUpdate();
            })
            .catch((error: any) => {
              console.error("Error reloading contract data:", error);
              resetContractUpdate();
            });
        }
      }
    }, [contractUpdated, contract?.id, resetContractUpdate]);

    useEffect(() => {
      const generatedFields = fieldsGeneralDataContract(
        response,
        response.contractNumber,
        contractStatusOptions,
      );
      console.log(
        " FIELDS GENERATED in fieldsGeneralDataContract:",
        generatedFields.map((f) => ({
          id: f.id,
          label: f.label,
          isEnable: f.isEnable,
        })),
      );
      setData(generatedFields);
    }, [response, contractStatusOptions]);

    return (
      <div
        className={`${style.containerSeeContactInfo}`}
        data-testid="content_general_contract"
      >
        <section className={style.containerTitleCardSeeContact}>
          <img src={Image.iconoContrato} alt="icono_doc" />
          <Typography className={style.titleCard} data-testid="title_content">
            Información General del Contrato
          </Typography>
        </section>
        <section className={style.containerBodySeeContact}>
          <Grid container direction={"row"} className={style.contentDetails}>
            {!isEditing ? (
              <>
                {data.map((field: IFieldForm, i: number) => {
                  return (
                    <Fragment key={i}>
                      {!["fechaServicios"].includes(field.id) && (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={4}
                          className={style.field}
                        >
                          <Typography className={style.titleDetails}>
                            {field.label}
                          </Typography>
                          {(() => {
                            if (field.id === "itemContractStatus") {
                              return (
                                <Box
                                  display={"flex"}
                                  alignItems={"center"}
                                  gap={1}
                                  width={"100%"}
                                >
                                  <Switch
                                    checked={hasContract}
                                    onChange={toogleHasContract}
                                  />
                                  <Typography className={style.titleDetails}>
                                    {hasContract ? "Vigente" : "Terminado"}
                                  </Typography>
                                </Box>
                              );
                            }
                            if (field.id === "itemFormContract") {
                              console.log("🎯 CONTRACT FIELD DETECTED:", {
                                id: field.id,
                                label: field.label,
                                isEnable: field.isEnable,
                                willRenderAs: field.isEnable
                                  ? "TotalValueField"
                                  : "Disabled Input",
                              });
                            }
                            return field.isEnable ? (
                              ["itemFormContract"].includes(field.id) ? (
                                <TotalValueField
                                  value={field.defaulValue!}
                                  index={i}
                                  confirmUpdate={confirmUpdateContractNumber}
                                  label="Número"
                                  data-testid={field.testId}
                                  userRol={accesRoles.adminUser}
                                />
                              ) : ["itemTotalValue"].includes(field.id) ? (
                                <TotalValueField
                                  value={field.defaulValue!}
                                  index={i}
                                  confirmUpdate={confirmUpdateTotal}
                                  label="Valor total"
                                  data-testid={field.testId}
                                  userRol={accesRoles.adminUser}
                                />
                              ) : (
                                <input
                                  className={style.inputDetails}
                                  type="text"
                                  defaultValue={field.defaulValue}
                                  data-testid={field.id}
                                />
                              )
                            ) : (
                              <input
                                className={style.inputDetails}
                                type="text"
                                disabled
                                defaultValue={field.defaulValue}
                                data-testid={field.id}
                              />
                            );
                          })()}
                        </Grid>
                      )}
                    </Fragment>
                  );
                })}
              </>
            ) : (
              <>
                <FormFilter
                  dataFields={dataFields}
                  getValueDatePickerEnd={getValueDatePickerEnd}
                  getValueDatePickerStart={getValueDatePickerStart}
                  onChangesDatePicker={onChangesDatePicker}
                  handleChange={handleChange}
                  handleUserAssignment={() => {}}
                  maxDate={maxDate}
                  values={values}
                />
                <Box
                  display={"flex"}
                  justifyContent={"flex-end"}
                  width={"100%"}
                  paddingRight={"1rem"}
                  marginTop={"1rem"}
                  gap={1}
                >
                  <Button
                    className={""}
                    onClick={() => setIsEditing(false)}
                    variant="contained"
                    data-testid="btn-cancel-edit"
                  >
                    Cancelar
                  </Button>
                  <Button
                    className={""}
                    onClick={() => handleSubmit()}
                    variant="contained"
                    data-testid="btn-save-contract"
                  >
                    Guardar
                  </Button>
                </Box>
              </>
            )}
          </Grid>
        </section>
        {(isLoading || loading) && <Spinner />}
      </div>
    );
  },
);
